import { render, staticRenderFns } from "./s-confirmation-dialog.vue?vue&type=template&id=0015913b"
import script from "./s-confirmation-dialog.vue?vue&type=script&lang=js"
export * from "./s-confirmation-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports